import api from "./API";
import getAd from "../utils/GetAd";
import getWWWUrl from "../utils/getWWWUrl";
import { getTrackingSiteUrl } from "../utils/trackingSiteContext";
import { POST_MEASSGE_GROUP_ID } from "../constants/ApiEndpointConstants";
import { postMessage } from "./PostMessageAPI";

export const countPixelEvent = (eventname, eventid) => {
  const siteUrl = getTrackingSiteUrl();

  if (!siteUrl) return Promise.resolve(null);

  let res = api.post(`https://www.adminv.online/api/Events/addevent`, {
    url: getWWWUrl(siteUrl),
    ad: getAd(),
    eventname,
    eventid,
  });

  let resData = res?.data;
  postMessage(
    `[--Count Pixel Event - ${eventname} | event_id : ${eventid}--]:${resData}`,
    POST_MEASSGE_GROUP_ID,
  );
  return res;
};
